import React from "react";
import Slider from "react-slick";
import BASE_URL from '../../cycles/variables'
import Dots from 'react-activity/lib/Dots';
import '../../style/circleLoader.css'

const SolicitorHomeSlider = (props) =>{
    let settings = {
        dots: false,
        infinite: true,
        speed: 1500,
        slidesToShow: 1,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000,
        fade:true,
        adaptiveHeight: true,
        swipeToSlide: false,
        swipe: false,
        className: 'sliderReactStyle',
        lazyLoad: true
    };
    return (
        <div>
            {
                props.imageCounter !== props.fetchedImageIndexes.length || props.fetchingImages?
                    <div className="sk-fading-circle">
                        <div className="sk-circle1 sk-circle"></div>
                        <div className="sk-circle2 sk-circle"></div>
                        <div className="sk-circle3 sk-circle"></div>
                        <div className="sk-circle4 sk-circle"></div>
                        <div className="sk-circle5 sk-circle"></div>
                        <div className="sk-circle6 sk-circle"></div>
                        <div className="sk-circle7 sk-circle"></div>
                        <div className="sk-circle8 sk-circle"></div>
                        <div className="sk-circle9 sk-circle"></div>
                        <div className="sk-circle10 sk-circle"></div>
                        <div className="sk-circle11 sk-circle"></div>
                        <div className="sk-circle12 sk-circle"></div>
                    </div>
                    :
                    null
            }

            {
                props.images.length > 0?
                    <Slider {...settings}>
                        {
                            props.images.map((item, index) => {return <div key={item.id}>
                                <div  className="solicitor-layout-title-wrapper"dangerouslySetInnerHTML={{__html: item.body}}></div>
                                <img className="img-responsive" onLoad={() => props.incrementImageCounter(index)} src={BASE_URL + 'images/' + item.title} key={item.id}/></div>})
                        }
                    </Slider>
                    :
                    null
            }
        </div>

    );
};

export default SolicitorHomeSlider;



